import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class DeliveriesService {

  private endpoint = environment.endpoint;
  // private url = environment.endpoint;
  private url = environment.cargaendpoint;
  constructor(private httpclient: HttpClient) { }

  create(delivery, token) {
    // const url = this.url + '/custom-carga/v2/delivery';
    let url_env = environment.type === 'stg' ? this.url : this.url
    const url = url_env + '/custom-carga/v2/delivery';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };
    return this.httpclient.post(url, delivery, httpOptions)
  }

  createMultiDrop(delivery, token) {
    let url_env = environment.type === 'stg' ? this.url : this.url
    const url = url_env + '/custom-carga/create/multidrop';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };
    return this.httpclient.post(url, delivery, httpOptions)
  }

  cancelDelivery(delivery, token) {

    let url_env = environment.type === 'stg' ? this.url : this.url
    const url = url_env + '/custom-carga/delivery-cancel/' + delivery.deliveryId;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };
    return this.httpclient.put(url, delivery, httpOptions)
  }

  cancelRental(rental, token) {

    let url_env = environment.type === 'stg' ? this.url : this.url
    const url = url_env + '/custom-carga/rental/cancel/' + rental.deliveryId;

    // // console.log("url", url)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };
    return this.httpclient.put(url, rental, httpOptions)

  }

  getPreSignedUrl(data, deliveryId, token) {
    const url = `${this.url}/custom-carga/initiate-upload-photo/${deliveryId}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      })
    };

    return this.httpclient.post(url, data, httpOptions)
  }

  uploadFileViaSignedUrl(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': data.contentType
      })
    };

    return this.httpclient.put(data.signedUrl, data.file, httpOptions)
  }

  multiUpload(files, token) {

    let formData: FormData = new FormData();
    files.forEach(element => {
      console.log("element", element)
      formData.append("files", element) // check this out for more info: https://developer.mozilla.org/en-US/docs/Web/API/FormData/append#example
    })
    // console.log("payloadData", payloadData)
    // formData.append('file', payloadData);


    let url_env = environment.type === 'stg' ? this.url : this.url
    const url = url_env + '/custom-ecarga/multiple/upload-file';

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey,
      })
    };

    console.log("formData", formData.get("file"))

    console.log("formData", formData, "httpOptions", httpOptions)

    return this.httpclient.post(url, formData, httpOptions)

  }

  getAll(data, token) {
    return new Promise(resolve => {
      let params = {}
      if (data != null) {
        params = data
      } else {
        params = {}
      }
      // const url = this.url + '/custom-carga/delivery/client';
      // let withoutv1 = this.url.split("/v1.0")
      // const url = withoutv1[0] + '/custom-carga/delivery/client'
      // let withoutv1 = environment.type === 'dev' ? this.url.split("/v1.0") : this.url
      let url_env = environment.type === 'stg' ? this.url : this.url
      const url = url_env + '/custom-carga/delivery/client'
      console.log("withoutv1", url);

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })

      this.httpclient.get(url, { headers, params })
        .subscribe(async (response) => {
          // // console.log("getAll response api", response);
          resolve(response)
        })
    })
  }

  getAllPackage(data, token) {
    let params = {}
    if (data != null) {
      params = data
    } else {
      params = {}
    }
    // const url = this.url + '/custom-carga/delivery/client';
    // let withoutv1 = this.url.split("/v1.0")
    // const url = withoutv1[0] + '/custom-carga/delivery/client'
    // let withoutv1 = environment.type === 'dev' ? this.url.split("/v1.0") : this.url
    // let url_env = environment.type === 'stg' ? this.url+'/v1.0' : this.url
    let url_env = environment.type === 'stg' ? this.url : this.url
    const url = url_env + '/custom-carga/delivery/client'
    // // console.log("withoutv1", url);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'x-api-key': environment.apiKey
    })

    return this.httpclient.get(url, { headers, params })

  }

  checkLocation(params, token) {
    return new Promise(resolve => {
      const url = this.url + '/custom-carga/delivery/map-checker';
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      });

      this.httpclient.get(url, { headers, params })
        .subscribe(resp => {
          // // console.log("checkLocation", resp);
          resolve(resp)
        })
    })
  }

  getBidding(params) {
    return new Promise(resolve => {

      let url_env = environment.type === 'stg' ? this.url : this.url
      const url = url_env + '/custom-carga/bidding/requests/' + params.deliveryId + '?page=1&rowsPerPage=1000&status=all'
      // // console.log("withoutv1", url);


      // custom-carga/bidding/requests/79c63b90-f604-11ed-a63f-a7ae4e0a70f8?page=1&rowsPerPage=1000&status=all

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        })
      };

      return this.httpclient.get(url, httpOptions)
        .subscribe(async response => {
          resolve(response)
        })

    })
  }

  approvedBid(params) {
    return new Promise(resolve => {

      let payload = {
        "transactionAmountInfo": {
          "price": params.transactionAmountInfo.ownerFee,
          "discount": params.transactionAmountInfo.discount > 0 ? params.transactionAmountInfo.discount : 0
        },
        "deliveryId": params.deliveryId
      }


      let url_env = environment.type === 'stg' ? this.url : this.url
      const url = url_env + '/custom-carga/bidding/approved/' + params.biddingId
      // // console.log("params", params);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        })
      };

      return this.httpclient.put(url, payload, httpOptions)
        .subscribe(async response => {
          resolve(response)
        }, async err => {
          resolve(false)
        })
    })
  }

  rejectBid(params) {
    return new Promise(resolve => {

      let url_env = environment.type === 'stg' ? this.url : this.url
      const url = url_env + '/custom-carga/bidding/rejected/' + params.biddingId
      // // console.log("params", params);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        })
      };

      return this.httpclient.put(url, params, httpOptions)
        .subscribe(async response => {
          resolve(response)
        })
    })
  }

  getBiddingCount(deliveryId) {
    return new Promise(resolve => {

      let url_env = environment.type === 'stg' ? this.url : this.url
      const url = url_env + '/custom-carga/bidding/requests/' + deliveryId + '?count=true&status=pending'
      // // console.log("withoutv1", url);


      // custom-carga/bidding/requests/79c63b90-f604-11ed-a63f-a7ae4e0a70f8?page=1&rowsPerPage=1000&status=all

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        })
      };

      return this.httpclient.get(url, httpOptions)
        .subscribe(async response => {
          resolve(response)
        })

    })
  }

  // Multi Drop
  getDrops(payload, token) {
    let url = this.url + "/custom-carga/delivery-drop/" + payload.deliveryId;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    });
    return this.httpclient.get(url, { headers });
  }

  getSubDelivery(){
    let url = this.url + "/custom-carga/delivery/client?shipperType=main";
    // let url = this.url + "/custom-carga/delivery/client?shipperType="+"stpdlove";
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    });
    return this.httpclient.get(url, { headers });
  }

}
